import * as Sentry from "@sentry/browser";
import {Action} from "@dp-instant/core";
import {Building} from "@game/coregame/ecs/entities/Building";
import {Fighter} from "@game/coregame/ecs/entities/Fighter";
import {GameModel} from "@game/coregame/model/GameModel";
import {TypesGame} from "@game/TypesGame";
import {inject, injectable} from "inversify";
import {PathHolder} from "../ecs/components/PathHolder";
import {FighterGroupsSystem} from "../ecs/systems/FighterGroupSystem";
import {math} from "../helpers";
import {Vector2} from "../interfaces/Vector2";
import {Spawner} from "../view/Spawner";

type BurstWaveActionPayload = {
    amount: number;
    spawner: Spawner;
    target: Building;
};

@injectable()
export class BurstWaveAction extends Action<BurstWaveActionPayload> {
    @inject(TypesGame.model)
    protected model: GameModel;

    async execute(payload: BurstWaveActionPayload) {
        let {amount} = payload;
        const {target, spawner} = payload;
        const step = 1 / (Spawner.UNITS_PER_WAVE - 1);
        const count = Math.ceil(amount);
        const scaleFactor = 1; //target.get(CapitalView)?.scale.x || 1;

        for (let i = 0; i < count; i++) {
            const shift =
                i % 2 == 0 ? 0.5 - step * Math.ceil(i / 2) : 0.5 + step * Math.ceil(i / 2);
            let amountInEntity = 1;
            if (amount < 1) {
                amountInEntity = amount;
            } else {
                amount -= 1;
            }
            const from = spawner.selfBuilding!;

            if (from === target) {
                Sentry.captureMessage("BurstWaveAction. from === target – logical mistake");
                return;
            }

            const pathHolder = from.get<PathHolder>(PathHolder);
            let fighterPath: Vector2[] = [];
            if (pathHolder) {
                const path = pathHolder.get(target);
                if (!path) {
                    Sentry.captureMessage(
                        "BurstWaveAction. Path is undefined, something weren't disposed properly"
                    );
                    return;
                }
                fighterPath = path.map(leftAndRight => math.lerp(...leftAndRight, shift));
            }
            const speed = Fighter.NORMAL_SPEED * scaleFactor;
            const group = FighterGroupsSystem.CreateNewGroup(
                fighterPath,
                speed,
                from.owner,
                target,
                from
            );
            FighterGroupsSystem.AddFighterToGroup(
                group,
                new Fighter(
                    from.owner,
                    from,
                    target,
                    shift,
                    fighterPath,
                    amountInEntity,
                    speed,
                    scaleFactor
                )
            );
        }
    }
}
